import { useCallback, useEffect, useState } from 'react'

import { useFlags } from '@joor/launchdarkly-react-client-sdk'

// eslint-disable-next-line no-restricted-imports
import { ICtaBannerItem } from '__generated__/contentful'

import { getCTABannerItems, getGradientColorById } from '../api'
import { DEFAULT_END_COLOR, DEFAULT_START_COLOR } from '../constants'
import { CTABannerItem, VisibleInField } from '../types'
import { getBannerItemToShow } from '../utils/getBannerItemToShow'

type Params = {
  visibleIn: VisibleInField
}

export const useCTABannerItem = ({ visibleIn }: Params) => {
  const flags = useFlags()
  const [bannerItemData, setBannerItemData] = useState<CTABannerItem>()

  const getCTABannerItemData = useCallback(async () => {
    const ctaBannerItems: ICtaBannerItem[] = await getCTABannerItems({
      visibleInPage: visibleIn,
    })

    if (!ctaBannerItems.length) {
      return
    }
    const ctaBannerItemFields = getBannerItemToShow(ctaBannerItems, flags)

    if (!ctaBannerItemFields) {
      return
    }

    const backgroundGradientFields = await getGradientColorById(
      ctaBannerItemFields.backgroundGradient.sys.id,
    )

    const bannerItemData: CTABannerItem = {
      ...ctaBannerItemFields,
      backgroundGradient: {
        startColor:
          backgroundGradientFields?.fields.startColor ?? DEFAULT_START_COLOR,
        endColor:
          backgroundGradientFields?.fields.endColor ?? DEFAULT_END_COLOR,
      },
    }
    setBannerItemData(bannerItemData)
  }, [flags, visibleIn])

  useEffect(() => {
    getCTABannerItemData()
  }, [getCTABannerItemData])

  return { bannerItemData }
}
